<script>
import HalfDashCard from "@/components/Cards/HalfDashCard";

export default {
    props: {
        meta: {},
        doPx: {
            type: Boolean,
            default: true
        }
    },
    components: { HalfDashCard }
};
</script>

<template>
    <div>
        <div class="row" :class="{ ' px-4': doPx }">
            <div class="col">
                <HalfDashCard
                    :title="$t('daylogs.statbox_working_hours')"
                    disable-hover
                    icon="far fa-calendar"
                    ><template slot="default">{{
                        meta.sums.month.total_time_sum | toTime
                    }}</template>
                    <template slot="footer">{{
                        $t("daylogs.statbox_btm_this_month")
                    }}</template></HalfDashCard
                >
            </div>
            <div class="col">
                <HalfDashCard
                    :title="$t('daylogs.statbox_goal')"
                    disable-hover
                    icon="far fa-bullseye-arrow"
                    ><template slot="default">{{
                        meta.sums.month.goal_time_sum | toTime
                    }}</template>
                    <template slot="footer">{{
                        $t("daylogs.statbox_btm_this_month")
                    }}</template></HalfDashCard
                >
            </div>
            <div class="col">
                <HalfDashCard
                    :title="$t('daylogs.statbox_balance')"
                    disable-hover
                    icon="far fa-balance-scale text-success"
                    ><template slot="default"
                        ><span
                            :class="{
                                'text-danger': meta.sums.month.diff_time_sum < 0
                            }"
                            >{{ meta.sums.month.diff_time_sum | rTime }}</span
                        ></template
                    >
                    <template slot="footer">{{
                        $t("daylogs.statbox_btm_this_month")
                    }}</template></HalfDashCard
                >
            </div>
            <div class="col">
                <HalfDashCard
                    :title="$t('daylogs.statbox_all_time_balance')"
                    disable-hover
                    icon="far fa-balance-scale text-info"
                    ><template slot="default"
                        ><span
                            :class="{
                                'text-danger':
                                    meta.sums.total.diff_time_sum_selected < 0
                            }"
                            >{{
                                meta.sums.total.diff_time_sum_selected | rTime
                            }}</span
                        ></template
                    >
                    <template slot="footer">{{
                        $t("daylogs.statbox_btm_up_to_this_month")
                    }}</template>
                </HalfDashCard>
            </div>
            <div class="col">
                <HalfDashCard
                    :title="$t('daylogs.statbox_all_time_balance')"
                    disable-hover
                    icon="far fa-balance-scale text-info"
                    ><template slot="default"
                        ><span
                            :class="{
                                'text-danger': meta.sums.total.diff_time_sum < 0
                            }"
                            >{{ meta.sums.total.diff_time_sum | rTime }}</span
                        ></template
                    >
                    <template slot="footer">{{
                        $t("daylogs.statbox_btm_all_time")
                    }}</template>
                </HalfDashCard>
            </div>
        </div>
    </div>
</template>
